<ng-container content>
    <div class="user-edit-page-wrapper" *ngIf="userCountry$ | async as userCountry">
        <aumico-user-general-information-page
            [supportedLocales]="supportedLocales"
            [countries]="countries"
            [proceedButtonEvent$]="proceedButtonEvent$"
            [userCountry]="userCountry"
            [save$]="saveUser.asObservable()"
            (initialUserGeneralInformation)="onInitialUserGeneralInformation($event)"
            (userGeneralInformationChanges)="onUserGeneralInformationChange($event)"
        ></aumico-user-general-information-page>
        <ham-button icon="assets/hamIcons/floppy-outline.svg" type="submit" size="lg" (buttonClick)="saveButtonClicked()">
            {{ 'aumico_button_save' | i18next }}
        </ham-button>
    </div>
</ng-container>
